<template>
  <div class="standard-scorm-player">
    <v-progress-linear
      v-if="loading"
      indeterminate
    />

    <v-alert
      v-else-if="error"
      class="mb-4"
      type="error"
    >
      {{ error }}
    </v-alert>

    <div
      v-else-if="completed"
      class="standard-scorm-complete d-flex flex-column align-center justify-center"
    >
      <h2 class="text-h5 font-weight-bold mb-2">
        {{ $bct(completionTitle) }}
      </h2>

      <p class="text-body-1 text-medium-emphasis">
        {{ $bct(completionSubtitle) }}
      </p>
    </div>

    <StandardIframe
      v-else-if="launchLink"
      @exit="emit('exit')"
      :src="launchLink"
      iframe-class="standard-scorm-iframe"
      message-type="iframe_exit"
    />
  </div>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  launchLink: {
    type: String,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: null,
  },
  completed: {
    type: Boolean,
    default: false,
  },
  completionTitle: {
    type: String,
    default: '',
  },
  completionSubtitle: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['exit']);
</script>

<style scoped>
.standard-scorm-player {
  width: 100%;
  min-height: 600px;
}

.standard-scorm-iframe {
  width: 100%;
  height: 80vh;
  min-height: 600px;
  border: none;
}

.standard-scorm-complete {
  min-height: 400px;
}
</style>
